import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/ValidateEmailRegisterDef';

const autoGenerateSuccess = (email: string, type: string, value: string) => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Validação com Sucesso',
      message: 'Validação com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        document: {
          type,
          value,
        },
        email,
      },
    },
    configResponse: {
      status: 200,
      data: {},
      headers: {},
    },
  };
  return validateSuccess;
};

const autoGenerateSuccessCPF = autoGenerateSuccess(
  MocksDef.EMAIL,
  'CPF',
  MocksDef.DOCUMENT_TYPE.CPF,
);
const autoGenerateSuccessRNE = autoGenerateSuccess(
  MocksDef.EMAIL,
  'RNE',
  MocksDef.DOCUMENT_TYPE.RNE,
);
const autoGenerateSuccessPASSPORT = autoGenerateSuccess(
  MocksDef.EMAIL,
  'PASSPORT',
  MocksDef.DOCUMENT_TYPE.PASSPORT,
);

const generatedSuccessMocks = [
  autoGenerateSuccessCPF,
  autoGenerateSuccessRNE,
  autoGenerateSuccessPASSPORT,
];

const autoGenerate = (email: string, type: string, value: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const body = {
        document: {
          type,
          value,
        },
        email: `${index}-${email}`,
      };
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};

const autoGenerateErrorsMock = () => {
  const responseCPF = autoGenerate(
    MocksDef.EMAIL,
    'CPF',
    MocksDef.DOCUMENT_TYPE.CPF,
  );
  const responseRNE = autoGenerate(
    MocksDef.EMAIL,
    'RNE',
    MocksDef.DOCUMENT_TYPE.RNE,
  );
  const responsePASSPORT = autoGenerate(
    MocksDef.EMAIL,
    'PASSPORT',
    MocksDef.DOCUMENT_TYPE.PASSPORT,
  );
  return [...responseCPF, ...responseRNE, ...responsePASSPORT];
};

const errorsGenerated = autoGenerateErrorsMock();

const ValidateMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default ValidateMocks;
